import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=13e36fca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=13e36fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e36fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e36fca')) {
      api.createRecord('13e36fca', component.options)
    } else {
      api.reload('13e36fca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=13e36fca&scoped=true&", function () {
      api.rerender('13e36fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rzNufY87sO7B/JS/comp/PopupBox.vue"
export default component.exports